/**
 * Small "pill" toast that surfaces note timing feedback (e.g. "Too early",
 * "Too late", "Wrong note!"). Shared by the sight-reading host (MainAppPhaser)
 * and the repertoire flow (RepertoirePlayContainerOSMD). Positioning is the
 * responsibility of the parent — this just renders the pill.
 */

import { Box } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

const FeedbackToast = ({ text }: { text: string | null }) => {
  const mobile = useMediaQuery('(max-width:960px)');
  return (
    <Box
      sx={{
        backgroundColor: '#CA7C62',
        color: 'white',
        borderRadius: '5px',
        zIndex: 2000,
        fontSize: mobile ? '14px' : '24px',
        padding: mobile ? '12px 20px' : '16px 64px',
      }}
    >
      {text}
    </Box>
  );
};

export default FeedbackToast;
